import useCollection from "./useCollection"

export default function usePortfolioAllocations({ portfolio }) {
  const key = `portfolios/${portfolio.id}/allocations`

  return useCollection({ key })
}
